module.exports = __webpack_public_path__ + "media/images/sport--skilanglauf-7fe38d58518a0f52bf130d32e5680ff1.png";